import "normalize.css/normalize.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/inter";
import { initializeI18n } from "../common/service/i18n";
import App from "./App.svelte";

initializeI18n();

const app = new App({
	target: document.getElementById("app") as Element,
});
export default app;
